import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { useFormik } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import * as Yup from 'yup';
import axios from 'axios';
// import { Editor } from "primereact/editor";

import { FileUpload } from "primereact/fileupload";
import appUrl from "../../../../constants/appUrl";
const AddEditAdminZTraining = ({ editable, setRes, rowData, setDialog, onHide }) => {
  const [channelList, setChannelList] = useState();
  const [productList, setProductList] = useState();
  const [apiRes, setApiRes] = useState();
  const [text, setText] = useState('');
  const [base64File, setBase64File] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([])
  const [temporarySelectedFiles, setTemporarySelectedFiles] = useState([]);

  const validationSchema = Yup.object().shape({
    productId: Yup.string().required('This is required'),
    channelID: Yup.string().required('This is required'),
    title: Yup.string().required('This is required'),
    description: Yup.string().required('This is required'),
  });
  const formik = useFormik({
    // validationSchema: validationSchema,
    initialValues: {
      productId: '',
      channelID: '',
      title: '',
      description: '',
      addAttachmentDTO:''
    },
    onSubmit: async (data) => {
      try {
        if (editable) {
          const response = await axios.patch(`${appUrl.baseUrl}api/OutageDegradation/UpdateOutageDegradation`, data);
          setApiRes(response);

          setRes(response);
        } else {
          let newData = {
            productId: data?.productId,
            channelID: data?.channelID,
            title: data?.title,
            description: data?.description,
            addAttachmentDTO: selectedFiles,
        }
          const response = await axios.post(`${appUrl.baseUrl}api/TrainingMaterial/AddTrainingMaterial`, newData);
          setApiRes(response);

          setRes(response);
        }

        setDialog(false);
      } catch (error) {
        // Handle error if needed
      } finally {
        console.log('Submitting form and hiding dialog');
        onHide();

      }
    },
  });
  
    //For Deleting File
    const handleCancelFile = (file) => {
      setSelectedFiles((prevFiles) => prevFiles.filter((f) => f !== file));
  };

  const handleFileUpload = (event) => {
      const files = Array.from(event.files);
      const updatedFiles = files.map((file) => {
          const reader = new FileReader();
          reader.onloadend = () => {
              const base64String = reader.result;
              setTemporarySelectedFiles((prevFiles) => [
                  ...prevFiles,
                  { attachmentPath: base64String }
              ]);
          };
          reader.readAsDataURL(file);
          return file;
      });
  };

  const handleAddFile = (event) => {
      setSelectedFiles((prevFiles) => [

          ...prevFiles,
          ...temporarySelectedFiles.map((file) => ({
              ...file,
              file_type_id: formik.values.file_type
          })).map((file) => ({
              ...file,
              attachmentPath: file.attachmentPath
          }))
      ])
      
      console.log("prevFiles", temporarySelectedFiles)
      setTemporarySelectedFiles([]);
      formik.setFieldValue("file_type", "")
  };

  useEffect(() => {
    formik.setFieldValue('productName', rowData?.productName);
    formik.setFieldValue('channelName', rowData?.channelName);
    formik.setFieldValue('title', rowData?.title);
  }, [rowData]);

  const getAllChannel = async () => {

    try {
      const response = await fetch(`${appUrl.baseUrl}api/Channel/GetAllChannels`)
      const data = await response.json();
      setChannelList(data);
    }
    catch (error) {
      console.error(error)
    }
  }
  const getAllProduct = async () => {

    try {
      const response = await fetch(`${appUrl.baseUrl}api/Product/GetAllProducts`)
      const data = await response.json();
      setProductList(data);
    }
    catch (error) {
      console.error(error)
    }
  }
  useEffect(() => {
    getAllChannel()
    getAllProduct()
  }, [])
  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid">
        <div className="col-4 md:col-4 lg:col-4 xs:col-12">
          <div className="flex flex-column">
            <label className="mb-2">Channel Name <span style={{ color: 'red' }}>*</span></label>
            <Dropdown
              value={formik.values.channelID}
              optionLabel="channelName"
              name="channelID"
              options={channelList}
              optionValue="channelID"
              placeholder="Select"
              onChange={formik.handleChange}
            />
            {formik.touched.channelName && formik.errors.channelName ? <div className='error'>{formik.errors.channelName}</div> : null}
          </div>
        </div>
        <div className="col-4 md:col-4 lg:col-4 xs:col-12">
          <div className="flex flex-column">
            <label className="mb-2">Product Name <span style={{ color: 'red' }}>*</span></label>
            <Dropdown
              value={formik.values.productId}
              optionLabel="productName"
              name="productId"
              options={productList}
              optionValue="productId"
              placeholder="Select"
              onChange={formik.handleChange}
            />
            {formik.touched.productName && formik.errors.productName ? <div className='error'>{formik.errors.productName}</div> : null}
          </div>
        </div>
        <div className="col-4 md:col-4 lg:col-4 xs:col-12">
          <div className="flex flex-column">
            <label className="mb-2">Title <span style={{ color: 'red' }}>*</span></label>
            <InputText
              name="title"
              id="title"
              placeholder="Enter title"
              value={formik.values.title}
              onChange={formik.handleChange}
            />
            {formik.touched.title && formik.errors.title ? <div className='error'>{formik.errors.title}</div> : null}
          </div>
        </div>
        <div className="col-4 md:col-4 lg:col-4 xs:col-12">
          <div className="flex flex-column">
            <label className="mb-2">description <span style={{ color: 'red' }}>*</span></label>
            <InputText
              name="description"
              id="description"
              placeholder="Enter description"
              value={formik.values.description}
              onChange={formik.handleChange}
            />
            {formik.touched.description && formik.errors.description ? <div className='error'>{formik.errors.description}</div> : null}
          </div>
        </div>
        
                <div className="flex w-full flex-column md:flex-row">
                    <div className="mb-2 flex flex-column md:w-5 md:ml-4">
                        <label htmlFor="countryId" >
                            <span className="text-2xl">File Upload</span>
                            <span className="Label__Required">*</span>
                        </label>
                        <FileUpload
                            accept='image*'
                            auto
                            mode="basic"
                            chooseLabel="Choose File"
                            className="p-mt-2"
                            onSelect={handleFileUpload}
                        />
                        <div className="dropdown-btn" >
                            <Button type="button" disabled={temporarySelectedFiles.length === 0 ? true : false} style={{ marginTop: "10px" }} icon={formik.values.file_type === "" || temporarySelectedFiles.length === 0 ? "pi pi-ban" : "pi pi-plus"} iconPos="right" className="p-button p-button-warning p-component pl-5 pr-5 button-orange" label="Add File" onClick={handleAddFile} ></Button>
                        </div>
                    </div>

                    <div className="mb-2 flex flex-column md:w-5 md:ml-4">

                        {selectedFiles && selectedFiles.length ?
                            <div className='card flex mt-2 flex-column md:w-full'>
                                {selectedFiles.length === 0 && selectedFiles.length === 0 ? (
                                    <p style={{ fontSize: "14px", fontWeight: "600", fontStyle: "italic", color: "white" }}>No docs added yet</p>
                                ) : (
                                    editable ? (
                                        selectedFiles && selectedFiles.map((file, index) => (
                                            <div key={index} className="flex flex-row justify-content-between align-items-center mt-2">
                                                {file?.file_extension.includes("jpeg") || file?.file_extension.includes("jpg") || file?.file_extension.includes("png") || file?.file_extension.includes("images") || file.file_extension.includes("image") ? (
                                                    <>
                                                        <span style={{ fontSize: "14px", color: "white" }}>Image:</span>
                                                        <img
                                                            src={file.attachmentPath}
                                                            alt={`Attachment ${index + 1}`}
                                                            style={{ maxWidth: "60px", maxHeight: "60px", border: "2px solid rgb(172 172 173)", borderRadius: "10px" }}
                                                        />
                                                    </>
                                                ) : (
                                                    <span style={{ fontSize: "14px", color: "white" }}>File: {file.file_name}</span>
                                                )}
                                                <div className="mt-2">

                                                    <Button
                                                        tooltip='Remove'
                                                        tooltipOptions={{ position: "top" }}
                                                        type='button'
                                                        icon="pi pi-times"
                                                        className='ml-2 fileuploadbtns'
                                                        style={{ backgroundColor: "#EF4444", border: "#EF4444" }}
                                                        onClick={() => handleCancelFile(file)}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        selectedFiles && selectedFiles.map((file, index) => (
                                            <div key={index} className="flex flex-row justify-content-between align-items-center mt-2">
                                                {/* {file?.file_extension.includes("jpeg") || file?.file_extension.includes("jpg") || file?.file_extension.includes("png") || file?.file_extension.includes("images") || file?.file_extension.includes("image") ? ( */}
                                                <>
                                                    <span style={{ fontSize: "14px", color: "white" }}>Image:</span>
                                                    <img
                                                        src={file.attachmentPath}
                                                        alt={`Attachment ${index + 1}`}
                                                        style={{ maxWidth: "60px", maxHeight: "60px", border: "2px solid rgb(172 172 173)", borderRadius: "10px" }}
                                                    />
                                                </>
                                                {/* ) : (
                                                    <span style={{ fontSize: "14px", color: "white" }}>File: {file.file_name}</span>
                                                )} */}
                                                <div className="mt-2">

                                                    <Button
                                                        tooltip='Remove'
                                                        tooltipOptions={{ position: "top" }}
                                                        type='button'
                                                        icon="pi pi-times"
                                                        className='ml-2 fileuploadbtns'
                                                        style={{ backgroundColor: "#EF4444", border: "#EF4444" }}
                                                        onClick={() => handleCancelFile(file)}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    )
                                )}
                            </div>
                            :
                            <div className='mt-2 card flex md:w-full'>
                                <p style={{ fontSize: "14px", fontWeight: "600", fontStyle: "italic", color: "white" }}>No docs added yet</p>
                            </div>
                        }
                    </div>
                </div>
        <div className="col-2 md:col-2 xl:col-12 lg:col-2 text-right">
          <Button className="Savebtn" label={editable ? 'Update' : 'Add New'} type="submit" />
        </div>
      </div>
    </form>
  )
}

export default AddEditAdminZTraining